import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=5bdc4737&"
import script from "./Download.vue?vue&type=script&lang=js&"
export * from "./Download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports